// Mega Menu Tabs functionality
(function() {
  // Function to handle tab switching
  function handleTabClick(event) {
    // Check if the clicked element is a tab button
    if (event.target.classList.contains('tab-button') || event.target.closest('.tab-button')) {
      const button = event.target.classList.contains('tab-button') ? event.target : event.target.closest('.tab-button');
      const tabToActivate = button.getAttribute('data-tab');
      const parentContainer = button.closest('.mega-menu-tabs-with-content');
      
      if (!parentContainer) return;
      
      // Remove active class from all tab buttons in this container
      parentContainer.querySelectorAll('.tab-button').forEach(btn => {
        btn.classList.remove('tab-button--active');
      });
      
      // Add active class to the clicked button
      button.classList.add('tab-button--active');
      
      // Hide all tab content in this container
      parentContainer.querySelectorAll('.mega-menu-tab-content').forEach(content => {
        content.classList.remove('tab-content--active');
      });
      
      // Show the selected tab content
      const activeTabContent = parentContainer.querySelector(`.tab-content--${tabToActivate}`);
      if (activeTabContent) {
        activeTabContent.classList.add('tab-content--active');
      }
      
      // Remove 'btn-active' from all mega-menu-view-all elements in this container
      parentContainer.querySelectorAll('.mega-menu-view-all').forEach(viewAll => {
        viewAll.classList.remove('btn-active');
      });
      
      // Add 'btn-active' to the corresponding mega-menu-view-all
      const activeViewAllButton = parentContainer.querySelector(`.btn-tab-${tabToActivate}`);
      if (activeViewAllButton) {
        activeViewAllButton.classList.add('btn-active');
      }
      
      // Prevent default behavior and stop propagation
      event.preventDefault();
      event.stopPropagation();
    }
  }
  
  // Function to initialize tabs when a menu is opened
  function initializeTabsOnMenuOpen(event) {
    // Check if the clicked element is a parent menu item or close to it
    if (event.target.closest('.submenu__item--parent')) {
      // Wait for the submenu to be fully visible
      setTimeout(function() {
        // Find all mega menu tabs within the opened submenu
        const openedSubmenus = document.querySelectorAll('.submenu.is-open, .submenu.is-opening');
        openedSubmenus.forEach(submenu => {
          const tabsContainers = submenu.querySelectorAll('.mega-menu-tabs-with-content');
          if (tabsContainers.length > 0) {
            // For each tabs container, ensure the first tab is active
            tabsContainers.forEach(container => {
              const firstTab = container.querySelector('.tab-button');
              const firstTabContent = container.querySelector('.mega-menu-tab-content');
              const firstViewAll = container.querySelector('.mega-menu-view-all');
              
              if (firstTab && !firstTab.classList.contains('tab-button--active')) {
                // Activate the first tab
                container.querySelectorAll('.tab-button').forEach(btn => {
                  btn.classList.remove('tab-button--active');
                });
                firstTab.classList.add('tab-button--active');
                
                // Show the first tab content
                container.querySelectorAll('.mega-menu-tab-content').forEach(content => {
                  content.classList.remove('tab-content--active');
                });
                if (firstTabContent) {
                  firstTabContent.classList.add('tab-content--active');
                }
                
                // Update view all button
                container.querySelectorAll('.mega-menu-view-all').forEach(viewAll => {
                  viewAll.classList.remove('btn-active');
                });
                if (firstViewAll) {
                  firstViewAll.classList.add('btn-active');
                }
              }
            });
          }
        });
      }, 100);
    }
  }
  
  // Add event listeners when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Use event delegation for tab clicks
    document.body.addEventListener('click', handleTabClick);
    
    // Use event delegation for menu opening
    document.body.addEventListener('click', initializeTabsOnMenuOpen);
    
    // Also handle hover events for desktop
    document.querySelectorAll('.submenu__item--parent').forEach(item => {
      item.addEventListener('mouseenter', function() {
        setTimeout(function() {
          const tabsContainers = item.querySelectorAll('.mega-menu-tabs-with-content');
          if (tabsContainers.length > 0) {
            tabsContainers.forEach(container => {
              const firstTab = container.querySelector('.tab-button');
              if (firstTab) {
                firstTab.click();
              }
            });
          }
        }, 100);
      });
    });
  });
})();